import { render, staticRenderFns } from "./PriceContextMenu.vue?vue&type=template&id=71aa976f&"
import script from "./PriceContextMenu.vue?vue&type=script&lang=js&"
export * from "./PriceContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports